const revealInterval = 50;
const hideInterval = 30;

function init() {

    jQuery.fn.reverse = [].reverse;

    function reveal(time, $links) {
        var timeStep = time;

        function applyCss(item) {
            $(item).css({
                'opacity': '1',
                'pointer-events': 'all',
            });
        }

        if (time > 0) {
            $links.each(function (key, item) {
                setTimeout(function () {
                    applyCss(item);
                }, time)
                time += timeStep;
            });
        }
        else {
            applyCss($links);
        }
    }

    function hide(time = 0, $links, filterGroup) {
        var timeStep = time;

        function applyCss(item) {
            $(item).css({
                'opacity': '0',
                'pointer-events': 'none',
            });
        }

        if (time > 0) {
            $links.reverse().each(function (key, item) {
                setTimeout(function () {
                    applyCss(item);
                    if (filterGroup && $links.length === (key + 1)) {
                        filterGroup.removeClass('active');
                    }

                }, time)
                time += timeStep;
            });
        }
        else {
            applyCss($links);
        }
    }

    $('#filter-link').click(function () {
        var windowPosition = window.pageYOffset;
        var elementPosition = $(".main-grid").offset().top;
        var windowHeight = $(window).height();
        var value = windowHeight - elementPosition + windowPosition;
        var $links = $('.filter-drop > a');
        var $filterGroup = $('.filter-drop');

        if ($(this).hasClass('filtered')) {
            $(this).removeClass('filtered');
            hide(hideInterval, $links, $filterGroup);
            if ($(window).width() <= '767') {
                $filterGroup.css('height', '100%');
            }
        } else {
            $(this).addClass('filtered');
            if ($(window).width() <= '767') {
                $filterGroup.css('height', value + 'px');
            }
            $filterGroup.addClass('active');
            hide(0, $links);
            reveal(revealInterval, $links);
        }
    })

    if ($(window).width() > '767') {
        $('.menu').click(function (e) {

            if(!e.target.classList.contains('menu-item-has-children')) {
                var $menuItems = $('.menu li');
                $('.hover-menu').toggleClass('hover-active');

                if ($(this).hasClass('active')) {
                    hide(hideInterval, $menuItems, $(this));
                } else {
                    $(this).addClass('active');
                    hide(0, $menuItems);
                    reveal(revealInterval, $menuItems)
                }
            }
        })
    } else {
        $('.menu').click(function () {
            if ($(this).hasClass('act')) {
                $(this).removeClass('act');
                $('body').removeClass('mobile-mode');
            } else {
                $(this).addClass('act');
                $('body').addClass('mobile-mode');
            }
        })

    }

    // $('.menu-item-has-children').append('<span class="menu-item-has-children-arrow"></span>');
    // const childArrow = $('.menu-item-has-children').find('.menu-item-has-children-arrow');
    // childArrow.on('click', function() {
    //     $(this).parent().toggleClass('show-submenu');
    // })
}

module.exports = {
    init: init
};